import { Scope } from '@/domain/external-invitation/entities/external-invitation.entity';
import { Sector } from '@/domain/impact/impact.entity';
import { selectOrganisationInfos } from '@/domain/organisation/organisation.selectors';
import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { getExternalInvitations } from './get-external-invitations.action';

export type CreateAndSendExternalInvitationParams = {
  name: string;
  email: string;
  limitDate: string;
  eventPosition: PositionGeocode | undefined;
  title: string;
  projectId: number; // can be project of date
  sector: Sector;
  scope: Scope;
};

export const createAndSendExternalInvitation = createAppAsyncThunk(
  'externalInvitation/createAndSendExternalInvitation',
  async (
    params: CreateAndSendExternalInvitationParams,
    {
      extra: { externalInvitationGateway, snackbarGateway },
      dispatch,
      getState,
    },
  ): Promise<void> => {
    const organisationId = selectOrganisationInfos(getState()).id;
    try {
      await externalInvitationGateway.invite(
        params.name,
        params.email,
        params.limitDate,
        params.eventPosition,
        params.title,
        params.sector,
        params.scope,
        params.projectId,
        organisationId,
      );
      showSnackbarSuccess(snackbarGateway);
      dispatch(getExternalInvitations({ projectId: params.projectId }));
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(
    translate('CreateAndSendExternalInvitation.Message.success'),
  );
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(
    translate('CreateAndSendExternalInvitation.Message.error'),
  );
}
